import makeStyles from '@mui/styles/makeStyles';
import { connect } from 'react-redux';

import PictureNav from '@/components/Layout/PictureNav';
import Link from '@/components/Link/Link';
import Logo from '@/components/Logo/Logo';
import { useThemeMode } from '@/hooks/useThemeMode';
import { darkGray, grey300 } from '@/theme/colors';

const useStyles = makeStyles(() => ({
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '15px 30px',
    boxSizing: 'border-box',
    margin: '0 auto',
    borderBottom: `1px solid ${grey300}`,
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
  },
  titleLogo: {
    borderLeft: `2px solid ${grey300}`,
    marginLeft: 10,
    display: 'block',
    padding: 10,
    fontSize: 18,
    color: darkGray,
  },
}));

function AdminHeader({ viewer }: any) {
  const s = useStyles();
  const { resolvedTheme } = useThemeMode();

  return (
    <div className={s.nav}>
      <Link to="/admin">
        <div className={s.logo}>
          <Logo dark={resolvedTheme === 'light'} />
          <span className={s.titleLogo}>Admin</span>
        </div>
      </Link>

      <PictureNav size={50} viewer={viewer} />
    </div>
  );
}

export default connect((state) => ({
  // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
  viewer: state.viewer,
}))(AdminHeader);
